import type { ReactNode } from 'react';
import styled from 'styled-components';

import { Vertical } from 'atoms/layout/flex';
import { LabelS } from 'atoms/typography';
import { Ellipsis } from 'atoms/typography/Ellipsis';

import { DumbClubAvatar } from '../DumbClubAvatar';

const Wrapper = styled(Vertical).attrs({ gap: 1, center: true })`
  justify-content: flex-start;
`;

const Avatar = styled(DumbClubAvatar)`
  --size: 3em;
  font-size: unset;
`;

type ClubProps = {
  name?: string;
  avatarUrl?: string | null;
  avatar?: ReactNode;
};

type Props = {
  team: ClubProps;
  bold?: boolean;
  Label?: typeof LabelS;
};

export const NamedClubAvatar = ({
  team,
  bold = false,
  Label = LabelS,
}: Props) => {
  const { name, avatar, avatarUrl } = team;
  return (
    <Wrapper>
      {avatar || <Avatar club={{ name, avatarUrl }} />}
      <Ellipsis>
        <Label bold={bold}>{name}</Label>
      </Ellipsis>
    </Wrapper>
  );
};
